import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ConsultantRegister() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", studio_name: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register/consultant", form);
      localStorage.setItem("gs_token", data.token);
      await refresh();
      toast.success("Account creato!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registrazione fallita");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#0F172A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><Logo className="h-16 mx-auto" variant="dark" /></Link>
        </div>
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <h1 className="text-2xl font-black text-[#1E293B] mb-1">Crea il tuo studio</h1>
          <p className="text-sm text-slate-500 mb-6">Gratuito per l'MVP. Ricevi il tuo QR personalizzato.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-gs">Nome studio</label>
              <input data-testid="register-studio-input" type="text" required value={form.studio_name}
                onChange={(e) => setForm({ ...form, studio_name: e.target.value })} className="input-gs"
                placeholder="es. Studio Rossi Infortunistica" />
            </div>
            <div>
              <label className="label-gs">Email professionale</label>
              <input data-testid="register-email-input" type="email" required value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-gs" />
            </div>
            <div>
              <label className="label-gs">Telefono</label>
              <input data-testid="register-phone-input" type="tel" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })} className="input-gs"
                placeholder="+39 …" />
            </div>
            <div>
              <label className="label-gs">Password (min 8 caratteri)</label>
              <input data-testid="register-password-input" type="password" required minLength={8} value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-gs" />
            </div>
            <button data-testid="register-submit-button" type="submit" disabled={loading}
              className="btn-gs-primary w-full disabled:opacity-60">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Crea studio"}
            </button>
          </form>
          <div className="mt-6 text-center text-sm text-slate-500">
            Hai già un account?{" "}
            <Link to="/login" className="text-[#2456C6] font-bold hover:underline">Accedi</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
